/**
 * 前台影豆只读接口
 * 对应后端 com.nwbd.controller.PowerConfigController
 */

import { httpGet, ServerType } from "@/service/httpRequest";

/** 消费业务类型选项，与 PowerConsumeTypeEnum 对齐 */
export interface PowerConsumeTypeOption {
  /** 业务类型编码 */
  code: number;
  /** 展示名称 */
  name: string;
}

/** 获取影豆消费业务类型枚举（code-name） */
export const getPowerConsumeTypes = (): Promise<PowerConsumeTypeOption[]> => {
  return httpGet<PowerConsumeTypeOption[]>(ServerType.Base, {
    url: "/ai-video/power/consume-types",
  });
};
